import { useMutation } from "urql";

import { CreateEmployeeCandidateRequestDocument } from "../../../graphql/generated.ts";

export function useCreateEmployeeCandidateRequest() {
  return useMutation(CreateEmployeeCandidateRequestDocument);
}
